"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExampleFiltersSelected = void 0;
const react_1 = __importDefault(require("react"));
const hooks_1 = require("../../hooks");
const ExampleFiltersSelected = props => {
  return react_1.default.createElement("div", {
    className: "rs__filters-selected"
  }, react_1.default.createElement("h3", {
    className: "rs__filters-selected__name"
  }, "Filters Selected"), react_1.default.createElement("ul", {
    className: "rs__filters-selected__list"
  }, props.selectedFilters.map(selectedFilter => react_1.default.createElement(ExampleFiltersSelectedItem, {
    selectedFilter: selectedFilter,
    handleRemove: props.handleRemove
  }))));
};
exports.ExampleFiltersSelected = ExampleFiltersSelected;
const ExampleFiltersSelectedItem = props => {
  const filtersHook = (0, hooks_1.useFilters)();
  const label = react_1.default.useMemo(() => {
    var _a;
    return parseFromSelectedValue(props.selectedFilter.value, ((_a = filtersHook.filters) !== null && _a !== void 0 ? _a : []).find(filter => filter.handle === props.selectedFilter.key));
  }, [props.selectedFilter.value, filtersHook.filters]);
  return react_1.default.createElement("li", {
    key: props.selectedFilter.key,
    className: "rs__filters-selected__list-item"
  }, react_1.default.createElement("label", {
    className: "rs__filters-selected__list-item-label",
    onClick: () => props.handleRemove(props.selectedFilter.key)
  }, react_1.default.createElement("span", {
    className: "rs__filters-selected__list-item-label"
  }, props.selectedFilter.label, ": "), react_1.default.createElement("span", {
    className: "rs__filters-selected__list-item-value"
  }, label)));
};
const parseFromSelectedValue = (value, filter) => {
  if (filter) {
    if (filter.displayType === "single") {
      if (filter.displayView === "range") {
        return value.label;
      }
      return value;
    }
    if (filter.displayType === "multi") {
      if (filter.displayView === "range") {
        return value.map(item => item.label).join(", ");
      }
      return value.join(", ");
    }
    if (filter.displayType === "slider") {
      return `${filter.displaySliderPrefix}${value[0]} to ${filter.displaySliderPrefix}${value[1]}`;
    }
  }
  const labelString = typeof value === "string" ? value : false;
  const labelObject = !Array.isArray(value) && typeof value === "object" ? `${value.start}-${value.end}`.replace("-0", "+") : false;
  const labelArray = Array.isArray(value) && typeof value[0] === "string" ? value.join(", ") : false;
  const labelArrayObject = Array.isArray(value) && typeof value[0] === "object" ? value.map(item => `${item.start}-${item.end}`.replace("-0", "+")).join(", ") : false;
  return labelString || labelObject || labelArray || labelArrayObject;
};